export const formConstants = {
  email: 'email',
  password: 'password',
  repeatPassword: 'repeatPassword',
}
